import {z} from 'zod';


export const b2bCalendarImage = z.object({
  id: z.coerce.number(),
  imageUrl: z.coerce.string(),
  sortOrder: z.coerce.number(),
});

export type b2bCalendarImage = z.infer<typeof b2bCalendarImage>;
